<template>
  <div>
        <div class="margin_bottom_lg">
            <h4 class="caps_upper color__grey_dark font-bold font-md">Settings</h4>
        </div>
        <div class="margin_top_lg row margin_bottom_lg">
            <h4 class="margin_top_lg col-4 col-lg-12">
                <router-link :to="{ name: 'offtaker.editprofile'}" class="color__grey_dark"
                :class="[$route.name === 'offtaker.editprofile' ? 'active_settings' : '']" >Edit Profile</router-link>
            </h4>
            
            <h4 class="margin_top_lg col-6 col-lg-12">
                <router-link :to="{ name: 'offtaker.changepassword'}" class="color__grey_dark"
                :class="[$route.name === 'offtaker.changepassword' ? 'active_settings' : '']">Change Password</router-link>
            </h4>
            <h4 class="margin_top_lg col-6 col-lg-12">
                <router-link :to="{ name: 'offtaker.deleteaccount'}" class="color__grey_dark"
                :class="[$route.name === 'offtaker.deleteaccount' ? 'active_settings' : '']">Delete Account</router-link></h4>
        </div>
  </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style>

</style>